var map = {
	"./footer_Instagram.svg": 131,
	"./footer_Youtube.svg": 562,
	"./footer_facebook.svg": 916,
	"./footer_twitter.svg": 297,
	"./logo_car.png": 550,
	"./logo_car_corto.svg": 144,
	"./logo_car_letra_blanca.svg": 177,
	"./logo_gobierno_colombia.png": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;